var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "observer", attrs: { tag: "form" } },
        [
          _c(
            "el-row",
            {
              staticClass: "container",
              attrs: { type: "flex", justify: "center", align: "middle" }
            },
            [
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c(
                    "form",
                    {
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.logar()
                        }
                      }
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { type: "flex", justify: "center" } },
                        [
                          _c("img", {
                            staticClass: "logo",
                            attrs: {
                              src: require("../../../assets/images/logo.png")
                            }
                          })
                        ]
                      ),
                      _c(
                        "el-row",
                        { attrs: { type: "flex", justify: "center" } },
                        [_c("p", [_vm._v("Cadastrar/Redefinir Senha")])]
                      ),
                      _c(
                        "el-row",
                        {
                          attrs: { type: "flex", justify: "left", gutter: 30 }
                        },
                        [
                          _c(
                            "el-col",
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required|min:6",
                                  name: "senha"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              placeholder:
                                                "Senha com no mínimo 6 caracteres",
                                              type: "password"
                                            },
                                            model: {
                                              value: _vm.senha,
                                              callback: function($$v) {
                                                _vm.senha =
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                              },
                                              expression: "senha"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-key icon",
                                              attrs: { slot: "suffix" },
                                              slot: "suffix"
                                            })
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          attrs: { type: "flex", justify: "start", gutter: 30 }
                        },
                        [
                          _c(
                            "el-col",
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules:
                                    "required|password_confirmation:@senha",
                                  name: "confirmacaoSenha"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              placeholder: "Confirmar senha",
                                              type: "password"
                                            },
                                            model: {
                                              value: _vm.confirmarSenha,
                                              callback: function($$v) {
                                                _vm.confirmarSenha =
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                              },
                                              expression: "confirmarSenha"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-key icon",
                                              attrs: { slot: "suffix" },
                                              slot: "suffix"
                                            })
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "end", gutter: 30 } },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.cadastrar()
                            }
                          }
                        },
                        [_vm._v("Confirmar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a767c5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a767c5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/CadastrarSenha.vue
// module id = null
// module chunks = 